module.exports = __webpack_public_path__ + "img/icon-52.d26f412e.svg";